import httpClient from "@plugins/http";

export default {
  fetchQuizActivityInfo(quizActivityId) {
    let timeStamp = Date.now();
    return httpClient.get(`/apis/quiz/activity/${quizActivityId}?t=${timeStamp}`);
  },
};
